import classnames from 'classnames'
import { BOX_BORDER_CLX } from '../../../../modules/consts/caf'
import { ICON_CHEVRON_RIGHT_GRAY } from '../../../../modules/svg/svg'
interface ArrowLinkBoxBGType {
  title: string | React.ReactFragment | React.ReactElement
  subText?: string | React.ReactFragment | React.ReactElement
  rightText?: string | number
  active?: boolean
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const ArrowLinkBoxBG = ({ title, rightText, active, subText, onClick }: ArrowLinkBoxBGType) => {
  return (
    <div
      className={classnames(
        `mb-[8px] min-h-[62px] px-[16px] py-[12px] shadow-sm ${BOX_BORDER_CLX} flex cursor-pointer items-center`,
        active ? 'bg-white' : 'bg-gray-100'
      )}
      onClick={onClick}
    >
      <div className="flex flex-1 items-center justify-between">
        <div>
          <h3 className={classnames('text-h5', active ? 'text-black' : 'text-gray-500')}>{title}</h3>
          {subText && <p className="text-[12px] capitalize  text-gray-500">{subText}</p>}
        </div>
        <div className="flex items-center">
          {!!String(rightText) && <span className="text-h5 mr-[16px] text-gray-500">{rightText}</span>}
          <img src={ICON_CHEVRON_RIGHT_GRAY} alt="chevron" />
        </div>
      </div>
    </div>
  )
}

export default ArrowLinkBoxBG
